// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"144":"71a3d5fe","145":"3a4201a1","201":"c5b10d47","211":"e4e5ef0b","324":"eae78b15","576":"37d6b2ab","646":"0f86d7c2","886":"7d1b87e2"}[chunkId] + ".js";
};